module.exports = __webpack_public_path__ + "static/media/33.342a6dac.mp3";